import React from 'react';
import { useLanguage } from './LanguageContext';
import { Star } from 'lucide-react';
export const Reviews = () => {
  const {
    t
  } = useLanguage();
  const reviews = [{
    text: t('rev.c1.text'),
    name: t('rev.c1.name')
  }, {
    text: t('rev.c2.text'),
    name: t('rev.c2.name')
  }, {
    text: t('rev.c3.text'),
    name: t('rev.c3.name')
  }];
  return <section id="reviews" className="bg-brand-navy py-20" data-id="element-193">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-194">
        {/* Rating Summary */}
        <div className="text-center mb-16" data-id="element-195">
          <h2 className="font-montserrat font-extrabold text-[80px] text-brand-gold leading-none mb-2" data-id="element-196">
            5.0
          </h2>
          <div className="flex justify-center gap-1 text-brand-gold mb-3" data-id="element-197">
            {[...Array(5)].map((_, i) => <Star key={i} size={28} fill="currentColor" data-id="element-198" />)}
          </div>
          <p className="font-inter text-white text-[14px] opacity-75" data-id="element-199">
            {t('rev.based')}
          </p>
        </div>

        {/* Review Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-200">
          {reviews.map((review, index) => <div key={index} className="bg-white rounded-[16px] border-t-[3px] border-brand-gold p-8 shadow-[0_8px_30px_rgba(0,0,0,0.20)] hover:shadow-[0_12px_40px_rgba(201,168,76,0.35)] transition-shadow relative" data-id="element-201">
              <div className="absolute top-4 right-5 text-[80px] text-brand-gold/15 font-serif leading-none select-none" data-id="element-202">
                "
              </div>

              <div className="flex gap-1 text-brand-gold mb-4 relative z-10" data-id="element-203">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-204" />)}
              </div>

              <p className="font-inter text-gray-700 mb-6 relative z-10 italic" data-id="element-205">
                "{review.text}"
              </p>

              <div className="relative z-10" data-id="element-206">
                <p className="font-montserrat font-bold text-brand-navy text-sm mb-1" data-id="element-207">
                  {review.name}
                </p>
                <p className="font-inter text-xs text-brand-gold font-medium" data-id="element-208">
                  {t('rev.badge')}
                </p>
              </div>
            </div>)}
        </div>

        {/* Bottom Bar */}
        <div className="text-center" data-id="element-209">
          <p className="font-inter text-brand-gold italic" data-id="element-210">{t('rev.bottom')}</p>
        </div>
      </div>
    </section>;
};